import { render, staticRenderFns } from "./ReportesInforme.vue?vue&type=template&id=178f00d9&"
import script from "./ReportesInforme.vue?vue&type=script&lang=js&"
export * from "./ReportesInforme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports